"use strict";
var _ = require("underscore");

module.exports = {
    numberWithCommas: function numberWithCommas(x) {
        x = Math.round(x);
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    }
};



// WEBPACK FOOTER //
// ./app/scripts/utils/helpers.js